import { convertFromHTML, EditorState, ContentState } from 'draft-js';
import Moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ButtonLoader from '../../Elements/Button/button';
import ThumbnailGrid from '../../Elements/Thumbnail/thumbnail';
import InComponentLoader from '../../Elements/Loader/componentloader';
import '../../../assets/css/siicex-usuario.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import React, { Component, useRef } from 'react';
import axios from 'axios';
import {API_URL,BASE_URL_RECURSOS, BASE_URL_CMS, BASE_URL_FRONTEND} from '../../../constants';
import Error from '../../Error/error';
import {stateToHTML} from 'draft-js-export-html';
import {DropDownList} from '../../Elements/Select/dropdown';
import {DropDownListChild} from '../../Elements/Select/dropdown';
import cookie from 'react-cookies';
import ImageUploader from 'react-images-upload';
import {toBase64} from '../../../functions';
import {updateValueInJson, showModalPageClass, hideModalPageClass} from '../../../functions';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import BulletinIcon from '@material-ui/icons/EventNote';
import ContenidoIcon from '@material-ui/icons/LineStyle';
import ImagenIcon from '@material-ui/icons/Image';
import DocumentIcon from '@material-ui/icons/AttachFile';
import VideoIcon from '@material-ui/icons/VideoLibrary';
import InfoIcon from '@material-ui/icons/HelpOutline';
import Checkbox from '@material-ui/core/Checkbox';
import ReactPlayer from 'react-player'
import { DropDownListMaster } from '../../Elements/Select/dropdownChild';
import { DropDownListChildMaster } from '../../Elements/Select/dropdownChild';
import {DropDownGeneral} from '../../Elements/Select/dropdownChild';
import {ValidateState} from '../../../functions';
import CKEditor from 'ckeditor4-react';

import ModalMultimedia from '../../Partials/ModalMultimedia';
import { validateImageFile, fetchImageDimensions, fetchImagePesoMaximo } from './utils';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  withRouter,
  useHistory,
  useParams,
} from 'react-router-dom';
import TagInput from '../../Elements/TagInput/TagInput';


let config = {    
  height : '600px',
  width :'100%',
addCss: '.divImagenConBajada img{width: 100% !important;}',
toolbarGroups: [
  { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
  { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
  { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
  { name: 'forms', groups: [ 'forms' ] },
  '/',
  { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
  { name: 'paragraph', groups: [ 'list', 'Outdent', 'blocks', 'align', 'bidi', 'paragraph','iframe' ,'Anchor'] },
  { name: 'links', groups: [ 'links' ] },
  { name: 'insert', groups: [ 'insert' ] },
  { name: 'styles', groups: [ 'styles' ] },
  { name: 'tools', groups: [ 'tools' ] },
  { name: 'others', groups: [ 'others' ] },
  { name: 'about', groups: [ 'about' ] }
],
removeButtons : 'Save,NewPage,Preview,Print,Templates,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,HiddenField,ImageButton,Button,Select,Textarea,TextField,Radio,Checkbox,Form,Subscript,Superscript,Strike,CopyFormatting,JustifyRight,BidiLtr,BidiRtl,Language,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,FontSize,Font,Maximize,ShowBlocks,About,Intent',
stylesSet : [
  { name: 'Enlace único', element: 'a', attributes: { 'class': 'enlaceUnico' } },
  { name: 'Botón rojo', element: 'a', attributes: { 'class': 'btnIrAlPortal' } },
  { name: 'Lista 2 Columnas', element: 'ul', attributes: { 'class': 'ListaEn2Columnas' } },
  { name: '1 Imagen Grande / Bajada', element: 'section',attributes: { 'class': 'divImagenConBajada' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
  { name: '2 Imagenes Pequeñas / Bajada', element: 'section',attributes: { 'class': 'divImagenMedianas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} },
  { name: '3 Imagenes Chiquitas / Bajada', element: 'section',attributes: { 'class': 'divImagenChiquitas' } , styles: {border: '2px solid #015696', padding: '4px', "border-Radius": "6px"} }
],
div_wrapTable : true,
extraAllowedContent: 'section class iframe style video embed',
allowedContent : true,
image: {toolbar: [ 'imageTextAlternative' ]},
extraPlugins : 'embed, iframe',
embed_provider : '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback} ',
skin : 'kama'
}

function TabPanel(props) {
    const { children, value, index } = props;

    return (
        <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-prevent-tabpanel-${index}`}
        aria-labelledby={`scrollable-prevent-tab-${index}`}>
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }

  function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };


const getFileBase64 = (file, callback) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => callback(reader.result);
    reader.onerror = error => {};
  };

const uploadImageCallBack = file => new Promise(
(resolve, reject) => getFileBase64(
    file,
    data => resolve({ data: { link: data } })
)
);

let countCaracteresResumenPdf = 0;

export default class edit_recurso extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nNumero: '',
            resource: [],
            response: [],
            error: [],
            key: 0,
            editorState: EditorState.createEmpty(),
            editorStateHTML : '' ,
            pictures: [],
            editorStateB: EditorState.createEmpty(),
            editorStateHTMLB : '' ,
            security: cookie.load('user'),
            roles: [],
            sector: [],
            userModified: [],
            userCreated: [],
            edit: false,
            roles: [],
            numeroTab: 0,
            HTML: '<span>&nbsp</span>',
            fieldReturnMultimedia:"",
            imagesToSelect: false,
            selectedImage: false,
            selectedFile: false,
            imageLimitDimension: null,
            imageLimitePesoBytes: null,
          }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeDate = this.handleInputChangeDate.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onEditorChangeEdit = this.onEditorChangeEdit.bind(this); 
        this.onEditorChangeEditResumen = this.onEditorChangeEditResumen.bind(this); 
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.currentImagePage = 1;
        this.asignDefaultImage = this.asignDefaultImage.bind(this);
        this.handleProductoChange = this.handleProductoChange.bind(this);
    
        const limiteMbImagen = 1; 
        this.imageLimitePesoBytes = limiteMbImagen * 1024 * 1024;
        this.VALIDAR_IMAGEN_AL_GRABAR = true;
    }

    onEditorChangeEdit(evt) {
      if (evt.editor!==undefined)
      {
        let html = evt.editor.getData();
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource["sContenido"] = html;
        this.setState({
          resource: copyResource, 
          HTML: html
        }, ()=> {});
      }
    }

    onEditorChangeEditResumen(evt) {
      let html = evt.editor.getData();
      let copyResource = JSON.parse(JSON.stringify(this.state.resource));
      let caracteres = html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').replace(/&\w+;/g ,'X').replace(/^\s*/g, '').replace(/\s*$/g, '').length;

      copyResource["recu_ResumenPdf"] = html;

      document.getElementById("count-caracteres").innerHTML = caracteres
      countCaracteresResumenPdf = caracteres;

      this.setState({
          resource: copyResource
      });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        if(event.target.id === "sArchivoNombre"){
          let texto = event.target.value.toLocaleLowerCase();
          let textoOri = event.target.value;
          let letras = "abcdefghijklmnopqrstuvwxyz0123456789-.";
          let _valueO = '';

          for (var i = 0; i < texto.length; i++) {
            if (letras.indexOf(texto[i]) != -1) {
              _valueO += textoOri[i];
            }
          }

          event.target.value = _valueO;
          copyResource['sArchivoNombre'] = _valueO;
        }
        else if(event.target.id === "recu_SeoUrlCanonical"){
          let texto = event.target.value.toLocaleLowerCase();
          let textoOri = event.target.value;
          let letras = "abcdefghijklmnopqrstuvwxyz0123456789-";
          let _value1 = '';

          for (var i = 0; i < texto.length; i++) {
            if (letras.indexOf(texto[i]) != -1) {
              _value1 += textoOri[i];
            }
          }

          event.target.value = _value1;
          copyResource['recu_SeoUrlCanonical'] = _value1;
        }
        else{
          copyResource[target.name] = value; 
        }

        if(event.target.name === "nTipoRecursoCodigo"){
          if(event.target.value.value === 14){
              document.getElementById('simple-tab-3').style.display = 'block';
              document.getElementById('simple-tab-4').style.display = 'block';
              document.getElementById('simple-tab-5').style.display = 'none';
              document.getElementById('simple-tab-6').style.display = 'block';
              document.getElementById('simple-tab-7').style.display = 'none';
              document.getElementById('div-sresumen').style.display = 'block';

              document.getElementById('tab1-notimail').style.display = 'block';
              document.getElementById('tab1-notipush').style.display = 'block';
              document.getElementById('tab1-portada').style.display = 'block';
              document.getElementById('tab1-noticia').style.display = 'block';
          }
          else{
              document.getElementById('simple-tab-3').style.display = 'none';
              document.getElementById('simple-tab-4').style.display = 'none';
              document.getElementById('simple-tab-5').style.display = 'block';
              document.getElementById('simple-tab-6').style.display = 'none';
              document.getElementById('simple-tab-7').style.display = 'block';
              document.getElementById('div-sresumen').style.display = 'none';
               
              document.getElementById('tab1-notimail').style.display = 'none';
              document.getElementById('tab1-notipush').style.display = 'none';
              document.getElementById('tab1-portada').style.display = 'none';
              document.getElementById('tab1-noticia').style.display = 'none';                 
          }
        }

        if(target.name === "nSectorCodigo")
        {
            let currentSectors = this.state.resource.nSectorCodigo || this.state.resource.lResourceSector || [];
            let currentIds = currentSectors.map(item => item.value || item.nSectorCodigo).sort().join(',');

            let newSectors = value || [];
            let newIds = newSectors.map(item => item.value || item.nSectorCodigo).sort().join(',');

            if (currentIds !== newIds) {
                copyResource["listLineaProducto"] = [];
                copyResource["listPartida"] = [];
                copyResource["nSectorCodigo"] = value;
            } else {
                copyResource["nSectorCodigo"] = value;
            }
        }

        this.setState({
          resource: copyResource
      });
    }

    changeTagInput(name, val){
      let copyResource = JSON.parse(JSON.stringify(this.state.resource));
      copyResource[name] = val;
      this.setState({ resource: copyResource });
    }

  handleProductoChange(event) {
        const selectedOptions = event.target.value; 
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        copyResource['listProductosSelected'] = selectedOptions;

        let productoNombres = '';
        if (selectedOptions && selectedOptions.length > 0) {
            productoNombres = selectedOptions.map(option => option.label).join(',');
        }
        
        copyResource['sProducto'] = productoNombres;
        this.setState({ resource: copyResource });
    }
        
   async componentDidMount(){
        await fetchImageDimensions().then(limits => {this.setState({ imageLimitDimension: limits });});
        await fetchImagePesoMaximo().then(maxMB => {this.setState({ imageLimitePesoBytes: maxMB * 1024 * 1024 });});

        localStorage.setItem("load", false);
        this.getImages()

        let search = window.location.search;
        let params = new URLSearchParams(search);

        const { handle } = this.props.match.params

        var key = this.props.location.state.key;

        const url = `${API_URL}ResourceUX/${key}/0`;
        axios.get(url).then(response => response.data)
        .then((data) => {
          
          let dataRes = data.result;
          console.log(url, dataRes)
          
            if (dataRes.lResourceItem) {
                dataRes.listPartida = dataRes.lResourceItem.map(item => ({
                    value: item.part_Id,
                    label: item.part_Nombre || item.part_Descripcion || item.part_Id 
                }));
            } else {
                dataRes.listPartida = [];
            }            

           if (dataRes.sProducto && dataRes.sProducto.length > 0) {
                dataRes.listProductosSelected = dataRes.sProducto.split(',').map(nombre => ({
                    value: nombre,
                    label: nombre 
                }));
            } else {
                dataRes.listProductosSelected = [];
            }

              if (dataRes.sProducto && dataRes.sProducto.length > 0) {
                  dataRes.listProductosSelected = dataRes.sProducto.split(',').map(item => ({
                      value: item, // Usamos el nombre como valor temporal
                      label: item
                  }));
              } else {
                  dataRes.listProductosSelected = [];
              }

            this.setState({

               resource: dataRes || '', 
               response: data, 
               error: data.Error 

              }, ()=> {

                const resumenHTML = this.state.resource.recu_ResumenPdf || '';
                const blocksFromHTML = convertFromHTML(resumenHTML);
                const editorState = (blocksFromHTML && blocksFromHTML.contentBlocks)
                  ? EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHTML))
                  : EditorState.createEmpty();

                this.setState({ editorState }, () => {
                    document.querySelector('.loader').classList.add('loader--hide');
                    document.getElementById('content-wrapper').removeAttribute("hidden");
                });

                const caracteres = (blocksFromHTML && blocksFromHTML.contentBlocks)
                  ? resumenHTML.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').replace(/&\w+;/g, 'X').replace(/^\s*/g, '').replace(/\s*$/g, '').length
                  : 0;

                const contadorElemento = document.getElementById("count-caracteres");
                if (contadorElemento) {
                    contadorElemento.innerHTML = caracteres;
                }
                countCaracteresResumenPdf = caracteres;

                document.getElementById('simple-tab-3').style.display = 'none';
                document.getElementById('simple-tab-4').style.display = 'none';
                document.getElementById('simple-tab-5').style.display = 'none';
                document.getElementById('simple-tab-6').style.display = 'none';
                document.getElementById('simple-tab-7').style.display = 'none';
                document.getElementById('div-sresumen').style.display = 'none';
                
                if(this.state.resource.nTipoRecursoCodigo == 14){
                  document.getElementById('simple-tab-3').style.display = 'block';
                  document.getElementById('simple-tab-4').style.display = 'block';
                  document.getElementById('simple-tab-5').style.display = 'none';
                  document.getElementById('simple-tab-6').style.display = 'block';
                  document.getElementById('simple-tab-7').style.display = 'none';
                  document.getElementById('div-sresumen').style.display = 'block';

                  document.getElementById('tab1-notimail').style.display = 'block';
                  document.getElementById('tab1-notipush').style.display = 'block';
                  document.getElementById('tab1-portada').style.display = 'block';
                  document.getElementById('tab1-noticia').style.display = 'block';                  
                }
                else{
                  document.getElementById('simple-tab-3').style.display = 'none';
                  document.getElementById('simple-tab-4').style.display = 'none';
                  document.getElementById('simple-tab-5').style.display = 'block';
                  document.getElementById('simple-tab-6').style.display = 'none';
                  document.getElementById('simple-tab-7').style.display = 'block';
                  document.getElementById('div-sresumen').style.display = 'none';

                document.getElementById('tab1-notimail').style.display = 'none';
                document.getElementById('tab1-notipush').style.display = 'none';
                document.getElementById('tab1-portada').style.display = 'none';
                document.getElementById('tab1-noticia').style.display = 'none';  

                }

                axios.get(`${API_URL}SecurityUX/${data.result.nUsuarioModificacion}/ /1`)
                .then(response => response.data)
                .then((dataResult) => {
                    this.setState({userModified: dataResult.result},() => {
                      axios.get(`${API_URL}SecurityUX/${data.result.nUsuarioCreacion}/ /1`)
                      .then(response => response.data)
                      .then((dataResult) => { this.setState({userCreated: dataResult.result},
                          () => {
                            document.querySelector('.loader').classList.add('loader--hide');
                            document.getElementById('content-wrapper').removeAttribute("hidden");
                          });
                      });
                    });
                });

              });
        })
        .catch(error => {
            console.log(error);
            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");
            toast.error("¡Error al inicializar!");
        });

    }


    handleClickCancel(e){
      this.props.history.push({
          pathname: '/recurso'
      });
    }

    async asignDefaultImage (codigo, data){
      const tipo = (codigo && typeof codigo === 'object') ? codigo.value : codigo;
      if (!tipo) return;
      const url = `${API_URL}CategoryUX/ObtenerCategoriaRecurso/${tipo}`;
      try{
          const res = await axios.get(url);
          if(res.data && res.data.result){
              const result = res.data.result;
              const defaultImg = result.imagenPorDefecto;
              if (data) {
                  data.sImagen = defaultImg;
              } else {
                  // fallback: actualizar estado si no se pasó data
                  this.setState(prev => ({
                      resource: updateValueInJson(prev.resource, 'sImagen', defaultImg)
                  }));
              }
          }
      } catch(err){
        // no throw - silencioso
      }
    }

    callFunctionButton = async (event) => {
        event.preventDefault();
      
        if (this.VALIDAR_IMAGEN_AL_GRABAR && this.state.selectedImage) {
            const val = await validateImageFile(
                this.state.selectedImage, 
                this.state.imageLimitDimension, 
                this.state.imageLimitePesoBytes
            );

            if (!val.ok) {
                toast.error(val.message);
                this.setState({loading: false}); 
                return; 
            }
        }

        let _isOk = true; 
        let tipoRecurso = this.state.resource.nTipoRecursoCodigo;

        // if(tipoRecurso != 14)
            {
          if(countCaracteresResumenPdf > 5000){toast.error('Error en Validación: Resumen del PDF supera el limite de los 5000 caracteres.'); _isOk = false;}
        }

        if(!_isOk){
          return;
        }

        this.setState({loading:true});

        const {history: {push}} = this.props;
        const url             = `${API_URL}ResourceUX/`;

        var dataToSave        = this.state.resource;
        dataToSave            = updateValueInJson(dataToSave, 'nUsuarioModificacion', this.state.security.nUsuCodigo);

        var nUbicacionCodigo  = this.state.resource.nUbicacionCodigo;
        var nSectorCodigo     = this.state.resource.nSectorCodigo;
        var listPartida       = this.state.resource.listPartida;
        var listLineaProducto = this.state.resource.listLineaProducto;
        var sProducto   = this.state.resource.sProducto;
        
        var ubicacion         = nUbicacionCodigo ? nUbicacionCodigo.map(v => v.value) : this.state.resource.lResourceCountry.map(v => v.pais_Id);
        var sector            = nSectorCodigo ? nSectorCodigo.map(v => v.value) : this.state.resource.lResourceSector.map(v => v.nSectorCodigo);
        var partida = listPartida ? listPartida.map(v => v.value) : [];
        var lineaProducto     = listLineaProducto ? listLineaProducto.map(v => v.value) : (this.state.resource.lResourceLineaProducto ? this.state.resource.lResourceLineaProducto.map(v => v.lpro_Id) : []);

        var sAutor    = this.state.resource.sAutor ;
        var sOrigen    = this.state.resource.sOrigen;

        dataToSave = updateValueInJson(dataToSave,'listLineaProducto', String(lineaProducto));
        dataToSave = updateValueInJson(dataToSave,'listPais', String(ubicacion));
        dataToSave = updateValueInJson(dataToSave,'listSector', String(sector));
        dataToSave = updateValueInJson(dataToSave,'listPartida', String(partida));
        dataToSave = updateValueInJson(dataToSave,'nLineaProductoCodigo', 0);
        dataToSave = updateValueInJson(dataToSave,'nUbicacionCodigo', 0);
        dataToSave = updateValueInJson(dataToSave,'nSectorCodigo', 0);
        dataToSave = updateValueInJson(dataToSave,'nTipoRecursoCodigo', (this.state.resource.nTipoRecursoCodigo.value?this.state.resource.nTipoRecursoCodigo.value:this.state.resource.nTipoRecursoCodigo));
        dataToSave = updateValueInJson(dataToSave,'sSector', String(sector));

        dataToSave = updateValueInJson(dataToSave,'cEstado', (this.state.resource.cEstado.value?this.state.resource.cEstado.value:this.state.resource.cEstado));
        dataToSave = updateValueInJson(dataToSave,'bActivo', (this.state.resource.bActivo.value?this.state.resource.bActivo.value:this.state.resource.bActivo));

        dataToSave = updateValueInJson(dataToSave,'recu_NotificarPorPush',   (this.state.resource.recu_NotificarPorPush.value ? this.state.resource.recu_NotificarPorPush.value : this.state.resource.recu_NotificarPorPush));
        dataToSave = updateValueInJson(dataToSave,'recu_NotificarPorCorreo', (this.state.resource.recu_NotificarPorCorreo.value ? this.state.resource.recu_NotificarPorCorreo.value : this.state.resource.recu_NotificarPorCorreo));
        dataToSave = updateValueInJson(dataToSave,'recu_SeoSeguirEnlace',   (this.state.resource.recu_SeoSeguirEnlace.value ? this.state.resource.recu_SeoSeguirEnlace.value : this.state.resource.recu_SeoSeguirEnlace));
        dataToSave = updateValueInJson(dataToSave,'recu_SeoMostrarMotores', (this.state.resource.recu_SeoMostrarMotores.value ? this.state.resource.recu_SeoMostrarMotores.value : this.state.resource.recu_SeoMostrarMotores));
        dataToSave = updateValueInJson(dataToSave,'cRec_Id', (this.state.resource.cRec_Id.value?this.state.resource.cRec_Id.value:this.state.resource.cRec_Id));
        dataToSave = updateValueInJson(dataToSave,'sUsuario', this.state.security.sUsuNombre + ' ' + this.state.security.sUsuApellidoPaterno);
        dataToSave    = updateValueInJson(dataToSave,'sAutor', sAutor.value ? sAutor.value : '')
        dataToSave    = updateValueInJson(dataToSave,'sOrigen', sOrigen.value ? sOrigen.value : '')
        dataToSave    = updateValueInJson(dataToSave,'sProducto', sProducto ? sProducto : '')

        // if(dataToSave.sEnlaceDocumento && dataToSave.sEnlaceDocumento !== ''){ 
        //   if(!dataToSave.sImagen || dataToSave.sImagen === ""){
        //       if((typeof dataToSave.nTipoRecursoCodigo === 'object' && dataToSave.nTipoRecursoCodigo.value === 14) || dataToSave.nTipoRecursoCodigo === 14){
              
        //       }else{
        //           await this.asignDefaultImage(dataToSave.nTipoRecursoCodigo.value, dataToSave);
        //       }
        //   }
        // }
        
if (!dataToSave.sImagen || dataToSave.sImagen === "") {
             let typeCode = this.state.resource.nTipoRecursoCodigo.value 
                           ? this.state.resource.nTipoRecursoCodigo.value 
                           : this.state.resource.nTipoRecursoCodigo;
            
            // Pasamos dataToSave para que asignDefaultImage actualice ese objeto y no el state visual
            await this.asignDefaultImage(typeCode, dataToSave);
        }

        const formData = JSON.stringify(dataToSave);
        // console.log("FORM: ", formData)
        axios.put(
            url, 
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
        ).then((data)=> {
              document.querySelector('.loader').classList.add('loader--hide');
              document.getElementById('content-wrapper').removeAttribute("hidden");

              if (data.data.isSucess){
                
                  toast.success('Recurso registrado correctamente. \n Se redireccionará al listado de recursos');
                  this.props.history.push({
                      pathname: '/recurso',
                  });

              } else {
                  this.setState({loading:false});
                  toast.error('No se pudo registrar el Recurso. \r');
              }
        }).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({loading:false});
        });
    }

    onEditorStateChange = (event) => {
        let html = event.editor.getData();
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));

        copyResource["sContenido"] = html;

        this.setState({
            resource: copyResource
        });
    };

    HandlePastedText = (text, html, editorState, onChange) => {
    }

    handleInputChangeDate(control){
        Moment.locale('es');
        let copyResource = JSON.parse(JSON.stringify(this.state.resource));
        copyResource['dFechaPublicacion'] = Moment(control).format();

         this.setState({
             resource: copyResource
        });
    }

    // onDrop = (file_container, flag) => {
    //   if(file_container.length<1) return;
    //   var file = file_container[0];
    //   if(file){
    //     toBase64(file).catch(e => {
    //       toast.error("Ocurrió un error al analizar el archivo, por favor seleccione otro")
    //     }).then(data => {
    //       let _tmp = {};
    //       _tmp[flag] = file;
    //       _tmp[flag].base64 = data;
    //       this.setState(_tmp);
    //     });
    //   }else{
    //     let _tmp = {};
    //     _tmp[flag] = false;
    //     this.setState(_tmp);
    //   }
    // }

onDrop = async (file_container, flag) => {
    if (file_container.length < 1) return;

    const file = file_container[0];
    if (!file) {
        this.setState({ [flag]: false });
        return;
    }

    if (flag === 'selectedImage') {
        const result = await validateImageFile(
            file, 
            this.state.imageLimitDimension, 
            this.state.imageLimitePesoBytes
        );

        if (!result.ok) {
            toast.error(result.message);
            this.setState({ selectedImage: false });
            return;
        }
    }

    toBase64(file).catch(e => {
        if (flag === 'selectedImage') {
            toast.error("Ocurrió un error al analizar la imagen, por favor seleccione otra");
        } else {
            toast.error("Ocurrió un error al analizar el archivo, por favor seleccione otro");
        }
        this.setState({ [flag]: false }); 
    }).then(data => {
        let _tmp = {};
        _tmp[flag] = file;
        _tmp[flag].base64 = data;
        this.setState(_tmp);
    });
}


    handleChangeTab = (event, newValue) => {
        this.setState({numeroTab: newValue});
    };

    getImages(page=1){
      const urlBase  = `${API_URL}`
      axios.get(urlBase + `FileUX/0/${page}/imagenes/all/all`).then(response => response.data)
      .then((data) => {
        this.currentImagePage = page
        this.setState({ imagesToSelect: data.result});
      }).catch(error => {
        console.error(error);
      });
    }

    selectImage = (img_obj) => {
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sImagen', img_obj.sArchivoRuta)
      _tmp = updateValueInJson(_tmp, 'nImagenCodigo', img_obj.nArchivoCodigo)
      this.setState({resource: _tmp}, () => {
        document.getElementById("thumbnail-modal-close").click();
      });
    }

    unSelectImage = () => {
      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'sImagen', null)
      _tmp = updateValueInJson(_tmp, 'nImagenCodigo', null)
      this.setState({resource: _tmp});
    }

  uploadImage = async () => { 
    let _file = this.state.selectedImage;
    
    if (!_file) {
        toast.error("No hay ninguna imagen seleccionada para subir.");
        return;
    }

    const r = await validateImageFile(
        _file, 
        this.state.imageLimitDimension, 
        this.state.imageLimitePesoBytes
    );

    if (!r.ok) {
        toast.error(r.message);
        return;  
    }
    
    let formData = {};
    let _filename = _file.name
    formData.sArchivoNombre = _filename;
    formData.sArchivoID = "03977376-4DEF-45BA-B810-934A55A6DA16"
    formData.sArchivoExtension = _filename.substring(_filename.lastIndexOf(".")+1, _filename.length)
    formData.sArchivoTipo = "imagenes"
    formData.sCategoriaArchivo = ""
    formData.sArchivoData = _file.base64;
    formData.nCodigoUsuario = this.state.security.nUsuCodigo;

    toast.info("Por favor espere mientras la imagen es procesada")
    axios.post((API_URL+`FileUX/`),
        ("'"+JSON.stringify(formData)+"'"),
        {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }
    ).then( data => {
        toast.success("La imagen ha sido subida correctamente")

        let _tmp = {};
        _tmp = updateValueInJson(this.state.resource, 'sImagen', data.data.result.sArchivoRuta)
        _tmp = updateValueInJson(_tmp, 'nImagenCodigo', data.data.result.nArchivoCodigo)
        this.setState({resource: _tmp}, this.getImages());
    }).catch((error)=> {
        console.error(error);
        toast.error('Error al subir la imagen');
    });
}

uploadFile = async() => {
    let _isOk = true;
    if(ValidateState(this.state.resource, 'sArchivoNombre', '')){ toast.error('Error en Validación: Debe ingresar el nombre del documento.'); _isOk = false; }

    let _file = this.state.selectedFile;

    if (!_file) {
        toast.error("Debe seleccionar un archivo PDF.");
        return;
    }

    if(!_isOk){return;}

    let formData = {};
    let _filename = _file.name
    
    formData.sArchivoID = "03977376-4DEF-45BA-B810-934A55A6DA16"
    formData.sArchivoExtension = _filename.substring(_filename.lastIndexOf(".")+1, _filename.length)
    formData.sArchivoNombre = `${this.state.resource.sArchivoNombre}.${_filename.substring(_filename.lastIndexOf(".") + 1, _filename.length)}`;
    formData.sArchivoTipo = "documentos"
    formData.sCategoriaArchivo = ""
    formData.sArchivoData = _file.base64;
    formData.nCodigoUsuario = this.state.security.nUsuCodigo;

    toast.info("Por favor espere mientras el documento es procesado, esto puede tomar hasta un minuto...")
    
    axios.post((API_URL+`FileUX/`),
      ("'"+JSON.stringify(formData)+"'"),
      {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8' ,
          'Accept': 'application/json'
        }
      }
    ).then( data => {
      toast.success("El documento ha sido subido correctamente")

      let _tmp = {};
      _tmp = updateValueInJson(this.state.resource, 'nArchivoCodigo', data.data.result.nArchivoCodigo);
      _tmp = updateValueInJson(_tmp, 'sEnlaceDocumento', data.data.result.sArchivoRuta);
      _tmp = updateValueInJson(_tmp, 'sArchivoNombre', data.data.result.sArchivoNombre);
      _tmp = updateValueInJson(_tmp, 'sArchivoNombreOld', data.data.result.sArchivoNombre);
      this.setState({resource: _tmp});
    }).catch((error)=> {
      console.error(error);
      toast.error('Error al subir el archivo');
    });
}


    paginationTable(){
      let data = this.state.imagesToSelect.length!=0 ? this.state.imagesToSelect : false;
      if(!data){
        data = this.state.imagesToSelect;
        if(!data || data.length==0) return;
      }

      let totalPages = data[0].totalPages;
      let options = false;
      options = [];

      if(totalPages>2) options.push(<span id={"pagination-inicio"} key={"pagination-inicio"} onClick={() => this.getImages(1)}>Inicio </span>);
      for(let index=1; index<(totalPages+1); index++){
        if(index>10 && index%10!=0) continue;
        options.push(
          <span id={"pagination-"+index}
            key={"pagination-link-"+index}
            onClick={() => this.getImages(index)}
            className={index===this.currentImagePage?"active":""}>
              {index}
          </span>
        );
      }
      if(totalPages>2) options.push(<span id={"pagination-fin"} key={"pagination-fin"} onClick={() => this.getImages(totalPages)}>Fin </span>);

      return (
        <div className="pagination" key={"pagination"}>
          {options}
        </div>
      );
    }
   
    letrasNumeroBlur = (e) => {
        let texto = e.target.value.toLowerCase();
        let textoOri = e.target.value;
        let result = "";
        let letras = "abcdefghijklmnñopqrstuvwxyz0123456789-.";
      
        for (var i = 0; i < texto.length; i++) {
          if (letras.indexOf(texto[i]) != -1) {
            result += textoOri[i];
          }
        }
        e.target.value = result;
        this.handleInputChange(e);
    }

    letrasCanonicalBlur = (e) => {
      let texto = e.target.value.toLowerCase();
      let textoOri = e.target.value;
      let result = "";
      let letras = "abcdefghijklmnopqrstuvwxyz0123456789-";
    
      for (var i = 0; i < texto.length; i++) {
        if (letras.indexOf(texto[i]) != -1) {
          result += textoOri[i];
        }
      }
      e.target.value = result;
      this.handleInputChange(e);
    }

    getResponse = (urlSeleccionada) => {
      let resource = this.state.resource;
      let fieldReturn = this.state.fieldReturnMultimedia;

      if(fieldReturn!== ""){

          resource[fieldReturn] = urlSeleccionada;

          this.setState({resource:resource, fieldReturnMultimedia:""});
      }

      hideModalPageClass("divGestorArchivosMultimedia");
    }

    showModalMultimedia = (clase = "", campo = "") => {
      this.setState({fieldReturnMultimedia:campo});
      showModalPageClass(clase);
    }

    render(){
        const { editorState } = this.state;

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });
        
        return (
                (this.state.response.statusCode===200)?
                (
                    <div id="detailBody" className="Site-content" >
                        <div className="loader"></div>
                        <form id="frmResource" name="frmResource" onSubmit={this.handleClickSubmit} >
                            <input type="hidden" id="dFechaModificacion" name="dFechaModificacion" defaultValue={this.state.resource.dFechaModificacion} />
                            <input type="hidden" id="dFechaPublicacion" name="dFechaPublicacion" defaultValue={this.state.resource.dFechaPublicacion} />
                            <input type="hidden" id="nUsuarioModificacion" name="nUsuarioModificacion" defaultValue={this.state.resource.nUsuarioModificacion} />
                            <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                            <div id="content">
                                <div id="Body" className="body-container container-fluid">
                                <div className="content-option">
                                        <div className="row ">
                                            <div className="col-md-12">
                                                <AppBar position="static" color="default" >
                                                    <Tabs   value={this.state.numeroTab} onChange={this.handleChangeTab}
                                                            scrollButtons="auto"
                                                            aria-label="icon label tabs example"
                                                            variant="fullWidth"
                                                            indicatorColor="secondary"
                                                            textColor="secondary">
                                                                <Tab icon={<BulletinIcon />} label="General" {...a11yProps(0)} />
                                                                <Tab icon={<ImagenIcon />} label="Imagen" {...a11yProps(1)} />
                                                                <Tab icon={<DocumentIcon />} label="Documento" {...a11yProps(2)} />
                                                                <Tab icon={<VideoIcon />} label="Video" {...a11yProps(3)} />
                                                                <Tab icon={<ContenidoIcon />} label="Contenido" {...a11yProps(4)} />
                                                                <Tab icon={<ContenidoIcon />} label="Resumen" {...a11yProps(5)} />
                                                                <Tab icon={<InfoIcon />} label="Informacion" {...a11yProps(6)} />
                                                                <Tab icon={<ImagenIcon />} label="SEO" {...a11yProps(7)} />
                                                    </Tabs>
                                                </AppBar>
                                                <TabPanel value={this.state.numeroTab} index={0}>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="nRecursoCodigo"><strong>Código</strong></label>
                                                                    <input type="text" readOnly name="nRecursoCodigo" onChange={this.handleInputChange} id="nRecursoCodigo" defaultValue={this.state.resource.nRecursoCodigo} className="form-control text-filter__form-control" placeholder="Código" />
                                                                </div>
                                                                <div className="form-group" style={{display:'none'}} >
                                                                    <label htmlFor="nTipoRecursoCodigo"><strong>Tipo</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownListMaster tipo={"padre"} valorHijo={this.state.resource.cRec_Id} valor={this.state.resource.nTipoRecursoCodigo} child="Categoria" name="nTipoRecursoCodigo" id="nTipoRecursoCodigo"  onChange={this.handleInputChange} clave={this.state.resource.nTipoRecursoCodigo} componente={"TipoRecurso"} />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="cRec_Id"><strong>Categoría</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownListChildMaster  tipo={"hijo"} isMulti={false} valorPadre={15}  valor={this.state.resource.cRec_Id}  name="CRec_Id" onChange={this.handleInputChange}  parent="TipoRecurso" id="CRec_Id" componente={"Categoria"} />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="sTitulo"><strong>Título</strong></label>
                                                                    <input type="text" name="sTitulo" id="sTitulo" onChange={this.handleInputChange} defaultValue={this.state.resource.sTitulo} className="form-control text-filter__form-control" placeholder="Título" />
                                                                </div>
                                                                <div id='div-sresumen' className="form-group">
                                                                    <label htmlFor="sResumen"><strong>Resumen</strong></label>
                                                                    <input type="text" name="sResumen" id="sResumen" onChange={this.handleInputChange} defaultValue={this.state.resource.sResumen} className="form-control text-filter__form-control" placeholder="Resumen" />
                                                                </div>
                                                                {/* <div className="form-group">
                                                                    <label htmlFor="sOrigen"><strong>Organización </strong></label>
                                                                      <input type="text" name="sOrigen" id="sOrigen" onChange={this.handleInputChange} defaultValue={this.state.resource.sOrigen} className="form-control text-filter__form-control" placeholder="Organización" />
                                                                </div> */}
                                                                {/* <div className="form-group">
                                                                    <label htmlFor="sAutor"><strong>Unidad organizacional</strong></label>
                                                                    <input type="text" name="sAutor" id="sAutor" onChange={this.handleInputChange} defaultValue={this.state.resource.sAutor} className="form-control text-filter__form-control" placeholder="Unidad organizacional" />
                                                                </div> */}

                                                                <div className="form-group">
                                                                    <label htmlFor="sOrigen" className='h6'>
                                                                        <strong>Organización</strong>
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList valor={this.state.resource.sOrigen} isMulti={false} name="sOrigen" id="sOrigen"  onChange={this.handleInputChange} clave={this.state.resource.sOrigen}
                                                                            componente={"Recurso_Organizacion"} 
                                                                        />
                                                                    </div>
                                                                </div> 
                                                                <div className="form-group">
                                                                    <label htmlFor="sAutor" className='h6'>
                                                                        <strong>Unidad organizacional</strong>
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList valor={this.state.resource.sAutor} isMulti={false} name="sAutor" id="sAutor"  onChange={this.handleInputChange} clave={this.state.resource.sAutor} 
                                                                            componente={"Recurso_OrganizacionUnidad"} 
                                                                        />
                                                                    </div>
                                                                </div>   

                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="nUbicacionCodigo"><strong>Mercado</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList valor={this.state.resource.lResourceCountry} isMulti={true} name="nUbicacionCodigo" id="nUbicacionCodigo"  onChange={this.handleInputChange} clave={this.state.resource.lResourceCountry} componente={"Ubicacion"} />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="nSectorCodigo">
                                                                      <strong>Sector</strong>
                                                                    </label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList 
                                                                          valor={this.state.resource.lResourceSector} 
                                                                          clave={this.state.resource.lResourceSector} 
                                                                          name="nSectorCodigo" 
                                                                          id="nSectorCodigo" 
                                                                          valorHijo={this.state.resource.lResourceLineaProducto}
                                                                          valorHijoPartida={this.state.resource.lResourceItem}
                                                                          child={["LineaProducto", "PartidaCascada"]}
                                                                          onChange={this.handleInputChange} 
                                                                          tipo="padre"
                                                                          componente={"Sector"} 
                                                                          isMulti={true} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="listPartida"><strong>Producto asociado</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownList
                                                                          name="sProducto" 
                                                                          id="sProducto" 
                                                                          valor={this.state.resource.listProductosSelected || []}
                                                                          clave={this.state.resource.listProductosSelected || []}
                                                                          metodo="added"
                                                                          etiqueta={"Producto"} 
                                                                          onChange={this.handleProductoChange}
                                                                          componente={"Productos"}         
                                                                          isMulti={true}
                                                                        />
                                                                    </div>
                                                                </div>                                                                 
                                                                <div className="form-group">
                                                                    <label htmlFor="listPartida"><strong>Partida</strong></label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownListChild 
                                                                            name="listPartida" 
                                                                            id="listPartida"  
                                                                            isMultiple={true}
                                                                            clave={this.state.resource.listPartida}
                                                                            onChange={this.handleInputChange} 
                                                                            parent="Sector" 
                                                                            componente={"PartidaCascada"} 
                                                                        />
                                                                    </div>
                                                                </div>

                                                                
                                                                <div className="form-group">
                                                                    <label htmlFor="listLineaProducto">
                                                                      <strong>
                                                                        Línea de Producto
                                                                      </strong>
                                                                    </label>
                                                                    <div className="col-sm-12">
                                                                        <DropDownListChild  
                                                                          isMultiple={true}  
                                                                          name="listLineaProducto" 
                                                                          onChange={this.handleInputChange}  
                                                                          parent="Sector" 
                                                                          id="listLineaProducto" 
                                                                          componente={"LineaProducto"} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                            <div className="form-group">
                                                                <label ><strong>Fecha de Publicación</strong></label>
                                                                <br/>
                                                                <DatePicker
                                                                    className="form-control text-filter__form-control_date col-md-6"
                                                                    onChange={this.handleInputChangeDate}
                                                                    value={Moment(this.state.resource.dFechaPublicacion).format('dddd DD, MMMM "YYYY"')}/>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="cEstado"><strong>Estado</strong></label>
                                                                <div className="">
                                                                    <DropDownList valor={this.state.resource.cEstado} name="cEstado" id="cEstado"  onChange={this.handleInputChange} clave={this.state.resource.cEstado} componente={"Estado"} />
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="bActivo">
                                                                  <strong>Activo</strong>
                                                                </label>
                                                                <div className="">
                                                                    <DropDownList 
                                                                      valor={this.state.resource.bActivo} 
                                                                      name="bActivo" 
                                                                      id="bActivo"  
                                                                      onChange={this.handleInputChange} 
                                                                      clave={this.state.resource.bActivo} 
                                                                      componente={"Activo"} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div id='tab1-portada' className="form-group">
                                                                    <label htmlFor="bPortada"><strong>Portada</strong></label>
                                                                    <div className="bPortada">
                                                                        <Checkbox  name="bPortada" id="bPortada" onChange={this.handleInputChange} value={this.state.resource.bPortada} checked={this.state.resource.bPortada} placeholder="Cabecera" />
                                                                    </div>
                                                                </div>
                                                                <div id='tab1-noticia' className="form-group">
                                                                    <label htmlFor="bImportante"><strong>Noticia Banner</strong></label>
                                                                    <div className="bImportante">
                                                                        <Checkbox  name="bImportante" id="bImportante" onChange={this.handleInputChange} checked={this.state.resource.bImportante} value={this.state.resource.bImportante} placeholder="Cabecera" />
                                                                    </div>
                                                                </div>
                                                                <div  id='tab1-notipush' className="form-group">
                                                                    <label htmlFor="recu_NotificarPorPush">
                                                                        <strong>Notificar por push</strong>
                                                                    </label>
                                                                    <div className="recu_NotificarPorPush">
                                                                        <Checkbox  
                                                                            name="recu_NotificarPorPush" 
                                                                            id="recu_NotificarPorPush" 
                                                                            onChange={this.handleInputChange} 
                                                                            placeholder="Notificar por push" 
                                                                            checked={this.state.resource.recu_NotificarPorPush}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div  id='tab1-notimail' className="form-group">
                                                                    <label htmlFor="recu_NotificarPorCorreo">
                                                                        <strong>Notificar por correo</strong>
                                                                    </label>
                                                                    <div className="recu_NotificarPorCorreo">
                                                                        <Checkbox  
                                                                            name="recu_NotificarPorCorreo" 
                                                                            id="recu_NotificarPorCorreo" 
                                                                            onChange={this.handleInputChange} 
                                                                            placeholder="Notificar por push"
                                                                            checked={this.state.resource.recu_NotificarPorCorreo} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                               
                                                                <div className="form-group">
                                                                    <label htmlFor="sEnlaceInteres"><strong>Enlace a recursos externos</strong></label>
                                                                    <input type="text" name="sEnlaceInteres" id="sEnlaceInteres" onChange={this.handleInputChange} defaultValue={this.state.resource.sEnlaceInteres} className="form-control text-filter__form-control" placeholder="Enlace a recursos externos" />
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="Recu_PalabrasClave">
                                                                        <strong>Palabras clave</strong>
                                                                    </label>
                                                                    <TagInput 
                                                                        defaultValue={this.state.resource['recu_PalabrasClave']}
                                                                        name="Recu_PalabrasClave" 
                                                                        id="Recu_PalabrasClave"
                                                                        onChange={(val) => this.changeTagInput('Recu_PalabrasClave', val)} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={1}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group ocultar">
                                                                <label htmlFor="sTituloImagen"><strong>Título Imagen</strong></label>
                                                                <input type="text" name="sTituloImagen"
                                                                  className="form-control text-filter__form-control"
                                                                  defaultValue={this.state.resource.sTituloImagen||""}
                                                                  onChange={this.handleInputChange} id="sTituloImagen"
                                                                  style={{padding: "15px"}}
                                                                  placeholder="Título archivo" />
                                                            </div>

                                                            {/* <div className="boletin__filters section__margin-bottom">
                                                                <button
                                                                  type="button" className="btn btn-primary btn-primary__tool"
                                                                  data-toggle="modal" data-target="#thumbnail-modal">
                                                                    {this.state.resource.sImagen?"CAMBIAR":"SELECCIONAR DE SERVIDOR"}
                                                                </button>
                                                            </div> */}
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <ImageUploader
                                                                  imgExtension={['.jpg', '.gif', '.png', '.gif']}
                                                                  accept='.jpg,.gif,.png'
                                                                  onChange={(file)=>this.onDrop(file,"selectedImage")}
                                                                  buttonText='Elegir una imagen...'
                                                                  label="Formatos aceptados: JPG - GIF - PNG - GIF"
                                                                  id="Uploader" singleImage={true} withIcon={true}
                                                                  withPreview={true} maxFileSize={5242880} />
                                                                <button disabled={!this.state.selectedImage}
                                                                  type="button" className="btn btn-primary btn-primary__tool"
                                                                  onClick={this.uploadImage}>
                                                                    SUBIR IMAGEN
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                {!this.state.resource.sImagen
                                                                  ? (<h6>No se ha seleccionado ninguna imagen</h6>)
                                                                  : (
                                                                    <div>
                                                                      <img className="col-md-12"
                                                                        src={BASE_URL_RECURSOS + this.state.resource.sImagen} />
                                                                      <br/><br/>
                                                                      <button
                                                                        type="button" className="btn btn-primary btn-primary__tool"
                                                                        onClick={this.unSelectImage}>
                                                                          Elimina imagen
                                                                      </button>
                                                                    </div>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={2}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="sArchivoNombre"><strong>Nombre Documento</strong></label>
                                                                <input type="text" name="sArchivoNombre"
                                                                  className="form-control text-filter__form-control"
                                                                  defaultValue={this.state.resource.sArchivoNombre}
                                                                  onChange={this.handleInputChange} id="sArchivoNombre"
                                                                  onBlur={this.letrasNumeroBlur}
                                                                  style={{padding: "15px"}}
                                                                  placeholder="Nombre documento (sin extensión)" />
                                                            </div>
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <strong>Enlace Documento: </strong>&nbsp;
                                                                    { 
                                                                      !this.state.resource.sEnlaceDocumento
                                                                      ? "No se ha agregado ningun documento"
                                                                      : (
                                                                        <a id="span-sEnlaceDocumento" target='_blank' href={BASE_URL_RECURSOS + this.state.resource.sEnlaceDocumento}>
                                                                          {BASE_URL_RECURSOS+this.state.resource.sEnlaceDocumento}
                                                                        </a>
                                                                      )
                                                                    }
                                                                </div>
                                                                <br></br>
                                                                <ImageUploader
                                                                  imgExtension={['.doc', 'docx', 'pdf', 'ppt', 'pptx']}
                                                                  accept='.pdf'
                                                                  onChange={(file)=>this.onDrop(file,"selectedFile")}
                                                                  buttonText='Click para elegir documento'
                                                                  label="Formato aceptado: PDF"
                                                                  id="Uploader" singleImage={true} withIcon={false}
                                                                  withPreview={false} maxFileSize={15242880} />
                                                                <button disabled={!this.state.selectedFile}
                                                                  type="button" className="btn btn-primary btn-primary__tool"
                                                                  onClick={this.uploadFile}>
                                                                    Subir imagen
                                                                </button>
                                                                <br/>
                                                                <br/>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                          <div className="boletin__filters section__margin-bottom">
                                                            <iframe src= {`https://docs.google.com/gview?url=${BASE_URL_RECURSOS+this.state.resource.sEnlaceDocumento}&embedded=true`}   className="col-md-12"  height="450px"/>
                                                          </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={3}>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="sEnlaceVideo"><strong>Enlace Video</strong></label>
                                                                    <input type="text" name="sEnlaceVideo" id="sEnlaceVideo" onChange={this.handleInputChange} defaultValue={this.state.resource.sEnlaceVideo} className="form-control text-filter__form-control" placeholder="Enlace Vídeo" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <ReactPlayer url={this.state.resource.sEnlaceVideo} playing={false} controls={true} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={4}>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <CKEditor
                                                                    id="sContenido"
                                                                    name="sContenido"
                                                                    config={config}
                                                                    data={this.state.resource.sContenido}
                                                                    onChange={this.onEditorChangeEdit}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={5}>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <label htmlFor="recu_ResumenPdf"><strong>Máximo 5000 caracteres (<span id='count-caracteres'>0</span> / 5000)</strong></label>
                                                                <CKEditor
                                                                    data={this.state.resource.recu_ResumenPdf || ''}
                                                                    onChange={this.onEditorChangeEditResumen} 
                                                                    config={config}
                                                                    id="recu_ResumenPdf"
                                                                    name="recu_ResumenPdf"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={6}>
                                                    <div className="row">
                                                      <div className="col-md-6">
                                                        <div className="boletin__filters section__margin-bottom">
                                                            <div className="form-group">
                                                                <label htmlFor="nNumero"><strong>Número Correlativo</strong></label>
                                                                <input type="text" name="nNumero" id="nNumero" readOnly={true} onChange={this.handleInputChange} defaultValue={this.state.resource.nNumero} className="form-control text-filter__form-control" placeholder="Código" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="nVistas"><strong>Número de Vistas</strong></label>
                                                                <input type="text" name="nVistas" id="nVistas" readOnly={true} onChange={this.handleInputChange} defaultValue={this.state.resource.nVistas} className="form-control text-filter__form-control" placeholder="Código" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="nDescargas"><strong>Número de Descargas</strong></label>
                                                                <input type="text" name="nDescargas" id="nDescargas" readOnly={true} onChange={this.handleInputChange} defaultValue={this.state.resource.nDescargas} className="form-control text-filter__form-control" placeholder="Código" />
                                                            </div>
                                                            <div className="form-group">
                                                                <label htmlFor="sUrlCanonical"><strong>URL amigable</strong></label>
                                                                <div style={{whiteSpace: "nowrap", overflowX: "scroll"}}>
                                                                    <label htmlFor="sUrlCanonical">{BASE_URL_FRONTEND+"/noticias/"}</label>
                                                                    <input type="text" name="sUrlCanonical" id="sUrlCanonical" onChange={this.handleInputChange} defaultValue={this.state.resource.sUrlCanonical} className="form-control text-filter__form-control" placeholder="" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-6">
                                                            <strong><hr/></strong>
                                                            <strong>FECHA DE CREACIÓN:</strong> {Moment(this.state.resource.dFechaCreacion).format('dddd DD, MMMM YYYY')}
                                                            <br/>
                                                            <strong>CREADO POR</strong> :  {this.state.userCreated.sUsuNombre} {this.state.userCreated.sUsuApellidoPaterno}
                                                            <br/><br/>
                                                            <strong>FECHA DE MODIFICACIÓN:</strong> {Moment(this.state.resource.dFechaModificacion).format('dddd DD, MMMM YYYY')}
                                                            <br/>
                                                            <strong>MODIFICADO POR:</strong> {this.state.userModified.sUsuNombre} {this.state.userModified.sUsuApellidoPaterno}
                                                      </div>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={this.state.numeroTab} index={7}>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoTitulo"><strong>SEO Título</strong></label>
                                                                    <input type="text" name="recu_SeoTitulo" id="recu_SeoTitulo" onChange={this.handleInputChange} maxLength={70} defaultValue={this.state.resource.recu_SeoTitulo} className="form-control text-filter__form-control" placeholder="SEO Título (70 caracteres)" />
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoDescripcion"><strong>SEO Descripción</strong></label>
                                                                    <textarea name="recu_SeoDescripcion" id="recu_SeoDescripcion" onChange={this.handleInputChange} maxLength={140} defaultValue={this.state.resource.recu_SeoDescripcion} className="form-control text-filter__form-control" placeholder="SEO Descripción (140) caracteres" style={{height: "100px"}}></textarea>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoUrlCanonical"><strong>SEO Url Canonical</strong></label>
                                                                    <input type="text" name="recu_SeoUrlCanonical" id="recu_SeoUrlCanonical" onBlur={this.letrasCanonicalBlur} onChange={this.handleInputChange} maxLength={1000} defaultValue={this.state.resource.recu_SeoUrlCanonical} className="form-control text-filter__form-control" placeholder="SEO Url canonical" />
                                                                </div>
                                                                <div className="txtFile x-1 relative">
                                                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "recu_SeoImagen")}/>
                                                                    <input type="text" placeholder="SEO Imagen" name='recu_SeoImagen' value={this.state.resource.recu_SeoImagen} maxLength={1000} onChange={this.handleInputChange} className="form-control text-filter__form-control"/>
                                                                </div>
                                                            </div>
                                                            <ModalMultimedia className="divGestorArchivosMultimedia" callback={this.getResponse.bind(this)}/>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoSeguirEnlace">
                                                                      <strong>Seguir enlace</strong></label>
                                                                    <div className="recu_SeoSeguirEnlace">
                                                                        <Checkbox  
                                                                            name="recu_SeoSeguirEnlace" 
                                                                            id="recu_SeoSeguirEnlace" 
                                                                            onChange={this.handleInputChange} 
                                                                            placeholder="Seguir enlace" 
                                                                            checked={this.state.resource.recu_SeoSeguirEnlace} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoMostrarMotores">
                                                                      <strong>Mostrar motores</strong></label>
                                                                    <div className="recu_SeoMostrarMotores">
                                                                        <Checkbox  
                                                                            name="recu_SeoMostrarMotores" 
                                                                            id="recu_SeoMostrarMotores" 
                                                                            onChange={this.handleInputChange} 
                                                                            placeholder="Mostrar motores" 
                                                                            checked={this.state.resource.recu_SeoMostrarMotores} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="recu_SeoScript"><strong>SEO Script</strong></label>
                                                                    <textarea name="recu_SeoScript" id="recu_SeoScript" onChange={this.handleInputChange} maxLength={1000} defaultValue={this.state.resource.recu_SeoScript} className="form-control text-filter__form-control" placeholder="Pegue aquí su código javascript" style={{height: "127px"}}></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-5">
                                                <button type="button" onClick={(event) => this.handleClickCancel(event)} className="btn btn-default btn-primary__submit">Cancelar</button>
                                                &nbsp;
                                                <ButtonLoader 
                                                  type="button"
                                                  text="GUARDAR" 
                                                  textProcessing="PROCESANDO..." 
                                                  loading={this.state.loading} 
                                                  callFunctionButton={(e) => this.callFunctionButton(e)}
                                                ></ButtonLoader>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </form>

                        <div className="modal fade" id="thumbnail-modal" tabIndex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
                          <div className="modal-subscription modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                              <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>

                              <div className="modal-body modal-subscription__body">
                                <p className="modal-subscription__title">Imagenes</p>

                                <p className="modal-subscription__info">
                                  <div className="recursos__wrapper-table">
                                    {this.state.imagesToSelect
                                      ? <ThumbnailGrid
                                          selectImage={this.selectImage}
                                          img_links={this.state.imagesToSelect}
                                          changePage={this.getImages}
                                          sizeX={"150px"} sizeY={"150px"} />
                                      : <InComponentLoader show={true} message={"Se está generando el Boletín HTML espere un momento"} />
                                    }
                                  </div>
                                </p>
                                {this.paginationTable()}
                              </div>

                              <div className="modal-footer">
                                <button id="thumbnail-modal-close" type="button" className="btn btn-primary btn-primary__submit" data-dismiss="modal" aria-label="Close">
                                  <i className="fas fa-close fa-sm"></i> &nbsp;
                                  <span>Cerrar</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                    </div>
                )
                :
                (
                    <Error StatusCode="500" StatusMessage="Error"></Error>
                )
                );
              }

}